import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SyncProcessorService } from '@vending/sync-engine-client';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { ErrorService } from 'src/packages/mitsBasics';
import { EventsService } from 'src/packages/mitsBasics';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- app-boundary-backlog
import { ObjectImageService } from 'src/app/providers/model-services/system';
import { OfflineDataService } from 'src/packages/mitsBasics';
import { WarehouseOrderAcceptanceModel } from '../models/warehouse-order';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WarehouseOrderAcceptanceService extends OfflineDataService<WarehouseOrderAcceptanceModel> {
  constructor(
    public indexedDBService: NgxIndexedDBService,
    public syncProcessor: SyncProcessorService,
    public http: HttpClient,
    public errorService: ErrorService,
    public events: EventsService,
    public objectImageService: ObjectImageService
  ) {
    super(
      indexedDBService,
      syncProcessor,
      'Warehouse::OrderAcceptance',
      http,
      errorService,
      events,
      'warehouse/order_acceptances/',
      'warehouse_order_acceptance',
      ['created_at, updated_at'],
      ['positions', 'bufferstock', 'basket', 'created_by']
    );
  }

  /**
   * Bilder versenden aus den lokalen Daten
   * @param order
   * @param mode - online/offline; Der Mode offline speichert die Bilder in der SyncQueue
   */
  public async updateImages(
    order: WarehouseOrderAcceptanceModel,
    mode: 'online' | 'offline' = 'online'
  ): Promise<any> {
    await this.objectImageService.sendImages(
      order,
      'images',
      'images_remote_ids',
      undefined,
      mode
    );
  }


  /**
   * Erzeugt/Speichert ein Objekt im Backend (je nachdem ob ID gesetzt)
   * @param object Zu speicherndes/erzeugendes Objekt
   * @param queueId
   */
  override saveRemote(object: WarehouseOrderAcceptanceModel, queueId: string|null = null): Observable<WarehouseOrderAcceptanceModel> {
    const cloned = { ...object } as Partial<WarehouseOrderAcceptanceModel>;
    delete cloned.bufferstock;
    delete cloned.basket;
    delete cloned.linked_to;
    return this.dataService.save(cloned as WarehouseOrderAcceptanceModel, queueId);
  }


  /**
   * Name des Icons für die Klasse
   * @return {string}
   */
  public get iconName(): string {
    return 'document-lock-outline';
  }
}
